module.exports = __webpack_public_path__ + "static/media/travel-hospitality.0ebff7e1.jpg";